import React from 'react';

const FileDownload = (props) => {  

    return (
        <div className={props.className}>
            <div className="fileDiv">
                <div className="fileElement">
                    <div className="fileItem">{props.fileName}</div>
                    <div className="fileItem push">
                        <span className="file-vertical-devider"></span>
                        <a className="file-download-icon pointer" href={props.filePath} download />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FileDownload;